import { render, staticRenderFns } from "./LangDialog.vue?vue&type=template&id=4b321b28&scoped=true&"
import script from "./LangDialog.vue?vue&type=script&lang=js&"
export * from "./LangDialog.vue?vue&type=script&lang=js&"
import style0 from "./LangDialog.vue?vue&type=style&index=0&id=4b321b28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b321b28",
  null
  
)

export default component.exports